const PUBLIC_ORIGIN = (process.env.VUE_APP_PUBLIC_ORIGIN || "https://www.zinnes.com.br").replace(/\/$/, "");

export function slugify(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function projectSlug(project) {
  if (!project) return "";
  return project.slug || project.project_slug || project.url_slug || "";
}

export function projectPath(project) {
  const id = project && project.id;
  if (!id) return "/";

  const slug = projectSlug(project);
  return slug ? `/obra/${id}/${slug}` : `/obra/${id}`;
}

export function projectRoute(project) {
  const id = project && project.id;
  if (!id) return { path: "/" };

  const params = { idObra: id };
  const slug = projectSlug(project);
  if (slug) params.slug = slug;

  return { name: "ObraOpenView", params };
}

export function publicUrl(path = "/") {
  if (/^https?:\/\//i.test(path)) return path;
  return `${PUBLIC_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}

export function canonicalProjectUrl(project) {
  return publicUrl(projectPath(project));
}

export function absoluteAssetUrl(url) {
  if (!url) return publicUrl("/img297.jpg");
  if (/^\/\//.test(url)) return `https:${url}`;
  if (/^https?:\/\//i.test(url)) return url.replace(/^http:\/\//i, "https://");
  return publicUrl(url);
}
